/**
 * @generated SignedSource<<8d9826f5d1ac17e49040be0476804ffa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_viewer">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_viewer";
};
export type PdpSharedShoppingButtons_viewer$key = {
  readonly " $data"?: PdpSharedShoppingButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "226ad70726378a939c3da6770883cbd6";

export default node;
